import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function OnIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M7.22695 7.1344C7.51985 7.42729 7.51985 7.90216 7.22696 8.19506C5.96112 9.46092 5.25 11.1778 5.25 12.968C5.25 14.7582 5.96112 16.4751 7.22695 17.7409C8.49282 19.0068 10.2097 19.7179 11.9999 19.7179C13.7901 19.7179 15.5069 19.0068 16.7728 17.7409C18.0386 16.4751 18.7498 14.7582 18.7498 12.968C18.7498 11.1778 18.0386 9.46092 16.7728 8.19506C16.4799 7.90216 16.4799 7.42729 16.7728 7.1344C17.0657 6.84151 17.5406 6.84151 17.8335 7.13441C19.3806 8.68158 20.2498 10.78 20.2498 12.968C20.2498 15.156 19.3806 17.2544 17.8335 18.8016C16.2863 20.3487 14.1879 21.2179 11.9999 21.2179C9.81185 21.2179 7.71347 20.3487 6.1663 18.8016C4.61915 17.2544 3.75 15.156 3.75 12.968C3.75 10.78 4.61914 8.68158 6.16629 7.13441C6.45918 6.84151 6.93405 6.84151 7.22695 7.1344Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0006 4.25073C12.4149 4.25073 12.7506 4.58652 12.7506 5.00073V12.398C12.7506 12.8122 12.4149 13.148 12.0006 13.148C11.5864 13.148 11.2506 12.8122 11.2506 12.398V5.00073C11.2506 4.58652 11.5864 4.25073 12.0006 4.25073Z"
        fill="white"
      />
    </SvgIcon>
  );
}
